// project imports
import { SearchParameterDTO } from "../../../common/types/common.dto.types";
import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";
import { StandardsPageInitialState } from "./StandardsPage.types";

// ==============================|| VIEWS - PAGES - STANDARD - API ||============================== //

// client object for axios calls to backend
const client = new ApiClient();

export const getStandardList = async (
  Params: SearchParameterDTO
): Promise<StandardsPageInitialState> => {
  try {
    const URL: string = `Standard/GetStandardList`;
    let data = {} as StandardsPageInitialState;
    await client
      .post<ActionResponseType>(URL, Params)
      .then((response: ActionResponseType) => {
        data.Data = response.Data;
      })
      .catch((error) => {
        // console.log(error);
        data = {} as StandardsPageInitialState;
      });

    return data;
  } catch (error) {
    // console.log(error);
    throw error;
  }
};
